import { icons as a } from "@phosphor-icons/core";
const s = "https://cdn.scalar.com/icons/phosphor/2.1.1", e = "regular", p = [
  "regular",
  "bold",
  "duotone",
  "fill",
  "light",
  "thin"
], h = (o) => {
  const [r, n, t] = o.startsWith("phosphor/") ? o.split("/") : ["phosphor", e, o];
  return { name: t, variant: n };
}, i = (o) => {
  const [r, n, t] = o.startsWith("phosphor/") ? o.split("/") : ["phosphor", e, o];
  return {
    name: t,
    variant: n
  };
};
function c(o) {
  const { variant: r, name: n } = h(o);
  return p.some((t) => t === r) ? a.some((t) => t.name === n) : !1;
}
function l(o) {
  const { variant: r, name: n } = i(o);
  return r === "regular" ? `${s}/${r}/${n}.svg` : `${s}/${r}/${n}-${r}.svg`;
}
function u(o, r) {
  return `phosphor/${r}/${o}`;
}
function m(o) {
  return p.map((r) => u(o, r));
}
const g = {
  name: "phosphor",
  icons: a.flatMap((o) => m(o.name)),
  belongsToLibrary: c,
  resolveUrl: l
};
export {
  i as parsePhosphorIconKey,
  h as parseStringAsPhosphorIconKey,
  p as phosphorIconVariants,
  g as phosphorLibrary
};
